function initializeChartbeat(site, section, author) {
   'use strict';
   window._sf_startpt=(new Date()).getTime();
   window._sf_async_config={};


   /** CONFIGURATION START **/
   window._sf_async_config.uid = 37612;
   window._sf_async_config.useCanonical = true;
   window._sf_async_config.domain = site;
   window._sf_async_config.sections = section;
   window._sf_async_config.authors = author;
   /** CONFIGURATION END **/
}

function loadChartbeat(section, author) {
   'use strict';

   var site = location.host;
   if(site == 'localhost' || site.indexOf("dev.cnn.com") >= 0 || site.indexOf("cnnpreview.cnn.com") >= 0 || site.indexOf("cnnpreview.turner.com") >= 0) {
       site = "ref.cnn.com";
   }
   initializeChartbeat(site, section, author);
   window._sf_endpt=(new Date()).getTime();
   var e = document.createElement('script');
   e.setAttribute('src',
       (('https:' === document.location.protocol) ?
         'https://a248.e.akamai.net/chartbeat.download.akamai.com/102508/' :
         'https://static.chartbeat.com/') + 'js/chartbeat.js');
       document.body.appendChild(e);

}

export default loadChartbeat;



// WEBPACK FOOTER //
// ./src/js/proj/chartbeat.js